
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';
import { Redirect } from '@/types/redirects';
import { Route } from 'vue-router';
import store from '@/store';
import ConfirmationDialog from '@/components/ConfirmationDialog.vue';
import AddRedirectDialog from '@/components/RedirectManager/AddRedirectDialog.vue';

@Component({
  components: { AddRedirectDialog, ConfirmationDialog },
})
export default class RedirectManager extends Vue {
  @Action('redirects/removeRedirect') removeRedirect!: Function;
  @Action('redirects/saveRedirect') saveRedirect!: Function;
  @Getter('redirects/redirects') redirects!: Redirect[];
  @Getter('redirects/editingRedirect') editingRedirect!: Redirect;
  @Mutation('redirects/clearEditingRedirect') clearEditingRedirect!: Function;
  @Mutation('redirects/setEditingRedirect') setEditingRedirect!: Function;

  headers = [
    { text: 'From', value: 'from' },
    { text: 'To', value: 'to' },
    { text: 'Actions', value: 'name', sortable: false, align: 'right' },
  ];

  pagination = {
    rowsPerPage: 50,
  };

  rowsPerPageItems = [
    10,
    25,
    50,
    { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 },
  ];

  selectedRedirect: Redirect | null = null;
  showAddRedirect: boolean = false;
  showConfirmDelete: boolean = false;

  onAdd() {
    this.clearEditingRedirect();
    this.showAddRedirect = true;
  }

  onDelete(redirect: Redirect) {
    this.selectedRedirect = redirect;
    this.showConfirmDelete = true;
  }

  onEdit(redirect: Redirect) {
    this.setEditingRedirect(redirect);
    this.showAddRedirect = true;
  }

  onConfirmDelete() {
    if (this.selectedRedirect !== null) {
      this.removeRedirect(this.selectedRedirect.id);
      this.showConfirmDelete = false;
      this.selectedRedirect = null;
    }
  }

  async beforeRouteEnter(to: Route, from: Route, next: Function) {
    await store.dispatch('redirects/getRedirects');
    next();
  }
}
